import React, { useEffect, useState } from 'react';
import './Profile.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faShoppingBasket,
    faStar,
    faGear,
    faRightFromBracket,
    faChevronRight,
    faBoxOpen,
    faClipboardList,
    faUsers,
    faShop,
    faBoxesStacked,
    faPen,
    faEye,
    faChevronDown,
    faFileLines,
    faTruck,
    faArrowTrendUp,
    faRobot,
    faUsersLine,
    faUserGear,
    faCircleQuestion,
    faLock
} from '@fortawesome/free-solid-svg-icons';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import NavInf from '../../components/NavInf/NavInf';
import { Link } from 'react-router-dom';
import WhatsAppBtn from '../../components/WhatsAppBtn/WhatsAppBtn.js';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../config/firebase';
import { redirectToLogin } from '../../utils/navigationHelper';

const Profile = () => {
    const [usuario, setUsuario] = useState(null);
    const [subMenuOpen, setSubMenuOpen] = useState(false);
    const [subMenuSAIOpen, setSubMenuSAIOpen] = useState(false);

    useEffect(() => {
        const userData = localStorage.getItem('usuario');
        if (userData) {
            setUsuario(JSON.parse(userData));
        }
    }, []);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (!user) {
                console.warn('Sesión expirada o cerrada. Limpiando datos...');
                localStorage.removeItem('usuario');
                setUsuario(null);
            }
        });

        return () => unsubscribe(); // Limpia el listener al desmontar
    }, []);

    useEffect(() => {
        const now = new Date();
        const tomorrowMidnight = new Date();
        tomorrowMidnight.setHours(24, 0, 0, 0); // próxima medianoche

        const msUntilMidnight = tomorrowMidnight.getTime() - now.getTime();

        const timeoutId = setTimeout(async () => {
            console.warn('Forzando cierre de sesión a medianoche...');
            await auth.signOut();
            localStorage.clear();
            redirectToLogin();
        }, msUntilMidnight);

        return () => clearTimeout(timeoutId);
    }, []);

    // Función de debugging
    window.debugDashboard = {
        verificarUsuario: () => {
            const user = auth.currentUser;
            console.log('Usuario actual:', user ? {
                email: user.email,
                uid: user.uid,
                displayName: user.displayName
            } : 'No autenticado');
        },

        generarTokenPrueba: async () => {
            const user = auth.currentUser;
            if (user) {
                const token = await user.getIdToken();
                const authData = {
                    token: token,
                    userInfo: { uid: user.uid, email: user.email },
                    timestamp: Date.now()
                };
                const encoded = btoa(JSON.stringify(authData));
                console.log('Token codificado:', encoded);
                console.log('URL completa:', `http://localhost:9002?auth=${encoded}`);
            }
        }
    };

    return (
        <>
            <Header />
            <div className='profile-container'>
                {usuario ? (
                    <div className='user-container'>
                        <div className='user-info'>
                            Bienvenido,<span className='user-name'>
                                {usuario.rol === 'proveedor' ? usuario.proveedorInfo.nombre_empresa : usuario.nombre.split(' ')[0].slice(0, 15)}
                            </span>
                        </div>
                        <div className='user-buttons'>
                            {(usuario.rol === 'proveedor' && usuario.proveedorInfo.hasPrivateCatalog) && (
                                <Link to={'/my-private-catalog'} className="user-button mg">
                                    <span className="icon-left">
                                        <FontAwesomeIcon icon={faLock} />
                                    </span>
                                    <span className="text">Mi catálogo privado</span>
                                    <span className="icon-right">
                                        <FontAwesomeIcon icon={faChevronRight} />
                                    </span>
                                </Link>
                            )}

                            {usuario.rol !== 'comerciante' && (
                                <Link to={usuario.rol === 'admin' ? '/admin' : '/my-products'} className="user-button">
                                    <span className="icon-left">
                                        <FontAwesomeIcon icon={usuario.rol === 'admin' ? faClipboardList : faBoxOpen} />
                                    </span>
                                    <span className="text">{usuario.rol === 'admin' ? 'Panel de administrador' : 'Mis productos'}</span>
                                    <span className="icon-right">
                                        <FontAwesomeIcon icon={faChevronRight} />
                                    </span>
                                </Link>
                            )}

                            {usuario.rol !== 'admin' ? (
                                <>
                                    <button
                                        className={`user-button ${usuario.rol === 'comerciante' ? 'mg' : ''} dropdown-toggle`}
                                        onClick={() => setSubMenuOpen(!subMenuOpen)}
                                    >
                                        <span className="icon-left">
                                            <FontAwesomeIcon id='icon-left' icon={usuario.rol === 'proveedor' ? faBoxesStacked : faArrowTrendUp} />
                                        </span>
                                        <span className="text">{usuario.rol === 'proveedor' ? 'Mi inventario' : 'Cuentas por pagar'}</span>
                                        <span className="icon-right">
                                            <FontAwesomeIcon id='icon-right' icon={subMenuOpen ? faChevronDown : faChevronRight} />
                                        </span>
                                    </button>

                                    <ul className={`submenu ${subMenuOpen ? 'open' : ''}`}>
                                        {usuario.rol === 'comerciante' && (
                                            <li>
                                                <Link to="/mis-proveedores" className="user-button">
                                                    <span className="icon-left subitem"><FontAwesomeIcon icon={faUsersLine} /></span>
                                                    <span className="text">Proveedores</span>
                                                    <span className="icon-right"><FontAwesomeIcon icon={faChevronRight} /></span>
                                                </Link>
                                            </li>
                                        )}

                                        <li>
                                            <Link to={usuario.rol === 'proveedor' ? "/my-products" : "/informe-deudas"} className="user-button">
                                                <span className="icon-left subitem"><FontAwesomeIcon icon={usuario.rol === 'proveedor' ? faBoxOpen : faFileLines} /></span>
                                                <span className="text">{usuario.rol === 'proveedor' ? 'Mis productos' : 'Informes'}</span>
                                                <span className="icon-right"><FontAwesomeIcon icon={faChevronRight} /></span>
                                            </Link>
                                        </li>

                                        {usuario.rol === 'proveedor' && (
                                            <li>
                                                <Link to="/edit-inventory" className="user-button">
                                                    <span className="icon-left subitem"><FontAwesomeIcon icon={faPen} /></span>
                                                    <span className="text">Editar inventario</span>
                                                    <span className="icon-right"><FontAwesomeIcon icon={faChevronRight} /></span>
                                                </Link>
                                            </li>
                                        )}

                                        {usuario.rol === 'comerciante' && (
                                            <>
                                                <button
                                                    className="user-button dropdown-toggle sai-button"
                                                    onClick={() => setSubMenuSAIOpen(!subMenuSAIOpen)}
                                                >
                                                    <span className="icon-left subitem">
                                                        <FontAwesomeIcon id='icon-left' icon={faRobot} />
                                                    </span>
                                                    <span className="text">Sistema SAI</span>
                                                    <span className="icon-right">
                                                        <FontAwesomeIcon id='icon-right' icon={subMenuSAIOpen ? faChevronDown : faChevronRight} />
                                                    </span>
                                                </button>

                                                <ul className={`submenu ${subMenuSAIOpen ? 'open' : ''}`}>
                                                    <li>
                                                        <Link to="/sai" className="user-button">
                                                            <span className="icon-left subitem2"><FontAwesomeIcon icon={faUserGear} /></span>
                                                            <span className="text">Usar estrategia</span>
                                                            <span className="icon-right"><FontAwesomeIcon icon={faChevronRight} /></span>
                                                        </Link>
                                                    </li>

                                                    <li>
                                                        <Link to="/sai-help" className="user-button">
                                                            <span className="icon-left subitem2"><FontAwesomeIcon icon={faCircleQuestion} /></span>
                                                            <span className="text">Ayuda</span>
                                                            <span className="icon-right"><FontAwesomeIcon icon={faChevronRight} /></span>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </>
                                        )}

                                        <li>
                                            {usuario.rol === 'proveedor' ? (
                                                <Link to="/inventory-overview" className="user-button">
                                                    <span className="icon-left subitem"><FontAwesomeIcon icon={faEye} /></span>
                                                    <span className="text">Ver inventario</span>
                                                    <span className="icon-right"><FontAwesomeIcon icon={faChevronRight} /></span>
                                                </Link>
                                            ) : (
                                                <Link to="/movimientos" className="user-button">
                                                    <span className="icon-left subitem"><FontAwesomeIcon icon={faTruck} /></span>
                                                    <span className="text">Registrar movimiento</span>
                                                    <span className="icon-right"><FontAwesomeIcon icon={faChevronRight} /></span>
                                                </Link>
                                            )}
                                        </li>
                                    </ul>
                                </>
                            ) : (
                                <></>
                            )}

                            {usuario.rol === 'comerciante' && (
                                <>
                                    <div className='separador-links' style={{ height: '1rem', backgroundColor: '#eee' }}></div>
                                    <Link to='/mis-pedidos' className="user-button">
                                        <span className="icon-left">
                                            <FontAwesomeIcon icon={faShoppingBasket} />
                                        </span>
                                        <span className="text">Mis pedidos</span>
                                        <span className="icon-right">
                                            <FontAwesomeIcon icon={faChevronRight} />
                                        </span>
                                    </Link>
                                </>
                            )}

                            <Link to={usuario.rol === 'proveedor' ? '/my-orders' : '/favorites'} className="user-button">
                                <span className="icon-left">
                                    <FontAwesomeIcon icon={usuario.rol === 'proveedor' ? faClipboardList : faStar} />
                                </span>
                                <span className="text">{usuario.rol === 'proveedor' ? 'Mis pedidos' : 'Favoritos'}</span>
                                <span className="icon-right">
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </span>
                            </Link>

                            {usuario.rol === 'proveedor' && (
                                <>
                                    <Link to='/my-customers' className="user-button">
                                        <span className="icon-left">
                                            <FontAwesomeIcon icon={faUsers} />
                                        </span>
                                        <span className="text">Mis clientes</span>
                                        <span className="icon-right">
                                            <FontAwesomeIcon icon={faChevronRight} />
                                        </span>
                                    </Link>

                                    <Link to='/my-store' className="user-button">
                                        <span className="icon-left">
                                            <FontAwesomeIcon icon={faShop} />
                                        </span>
                                        <span className="text">Mi tienda</span>
                                        <span className="icon-right">
                                            <FontAwesomeIcon icon={faChevronRight} />
                                        </span>
                                    </Link>
                                </>
                            )}

                            <Link to="/configuracion" className="user-button">
                                <span className="icon-left">
                                    <FontAwesomeIcon icon={faGear} />
                                </span>
                                <span className="text">Configuración</span>
                                <span className="icon-right">
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </span>
                            </Link>

                            <Link to="/logout" className="user-button logout">
                                <span className="icon-left">
                                    <FontAwesomeIcon icon={faRightFromBracket} />
                                </span>
                                <span className="text">Cerrar sesión</span>
                                <span className="icon-right">
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </span>
                            </Link>
                        </div>
                    </div>
                ) : (
                    <div className='no-user-container'>
                        <h2>No has iniciado sesión</h2>
                        <p>Para ver tu perfil, por favor inicia sesión.</p>
                        <Link to="/login" className="btn-login">Iniciar sesión</Link>
                    </div>
                )}
            </div>
            <WhatsAppBtn />
            <NavInf selected={"profile"} />
            <Footer navinf={true} />
        </>
    );
};

export default Profile;
